import { connect } from 'react-redux';
import Marketing from '../../../components/marketing/Marketing';
import { getMasivos } from 'core/slices/masivos';
import { getTemplates } from 'core/slices/templates';
import { masivos, templates, profile, sucursal_id } from 'core/selectors';

export default connect(
  state => ({
    masivos: masivos(state),
    templates: templates(state),
    profile: profile(state),
    sucursal_id: sucursal_id(state),
  }),
  { getMasivos, getTemplates },
)(Marketing);
